import React, { useEffect, useState } from "react";
import { Container, Table, Button } from "react-bootstrap";
import api from "./api";

function ManageDemoRequests() {
  const [data, setData] = useState([]);

  const fetchData = async () => {
    const res = await api.get("/UiplusDemoRequests");
    setData(res.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteRequest = async (id) => {
    await api.delete(`/UiplusDemoRequests/${id}`);
    fetchData();
  };

  return (
    <Container className="py-5">
      <h3>Demo Requests</h3>

      <Table bordered responsive>
        <thead>
          <tr>
            <th>Product</th>
            <th>Business</th>
            <th>Contact</th>
            <th>Email</th>
            <th>Requirement</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {data.map((item) => (
            <tr key={item.id}>
              <td>{item.product}</td>
              <td>{item.businessName}</td>
              <td>{item.contactNo}</td>
              <td>{item.email}</td>
              <td>{item.requirement}</td>
              <td>
                {new Date(item.createdDate).toLocaleDateString()}
              </td>
              <td>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => deleteRequest(item.id)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}

export default ManageDemoRequests;